import request from './index'

/** 首页用量（会按间隔校准 user.kjzls） */
export function fetchUsage() {
  return request.get('/user/usage.php')
}

/** 手动触发空间校准（汇总图片/音频/文档等占用） */
export function calibrateStorage() {
  return request.post('/user/calibrate-storage.php')
}

/** 在线心跳：刷新 user.yhzxsj，供运营后台统计在线人数 */
export function pingOnlineHeartbeat() {
  return request.get('/user/heartbeat.php', { silent: true })
}

/** 用户设置资料 */
export function fetchUserProfile() {
  return request.get('/user/profile.php')
}

/** 修改密码 */
export function changePassword(payload) {
  return request.post('/user/password.php', payload)
}

/** 修改绑定邮箱（send_old / verify_old / send_new / verify_new） */
export function changeEmail(payload) {
  return request.post('/user/email.php', payload)
}

/** 注销账号 */
export function deleteAccount(confirmPhrase) {
  return request.post('/user/delete.php', { confirmPhrase })
}

/** 微信绑定状态 */
export function fetchWechatStatus() {
  return request.get('/user/wechat.php')
}

/** 发起微信绑定（返回授权链接） */
export function startWechatBind() {
  return request.post('/user/wechat.php', { action: 'start' })
}

/** 解绑微信 */
export function unbindWechat() {
  return request.post('/user/wechat.php', { action: 'unbind' })
}
